import moment from 'moment';
import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Label, Row } from 'reactstrap';
import ApiRest from '../../ayudas/apiRest';
import _valid from '../../validations';

export default class Historial extends Component {

    constructor(props) {
        super(props);
        this.apiRest = new ApiRest(props);
        this.state = {
            historiales: []
        }
    }

    componentDidMount() {
        this.apiRest.get("/historialDeSolicitud/" + this.props.solicitud).then(resultado => {
            if (resultado.exitoso) {
                this.setState({
                    historiales: resultado.data.map(his => {
                        const formateada = moment(his.fecha).format("YYYY-MM-DD HH:mm");
                        const tipo = ((formateada[11] + formateada[12]) < 12) ? "AM" : "PM";
                        his["fecha"] = formateada + " " + tipo;
                        return his;
                    })
                });
            }
        });
    }


    render() {
        const { historiales } = this.state;
        return (
            _valid(historiales) &&
            historiales.map((historial, indice) =>
                <div key={indice}>
                    <Card>
                        <CardHeader>
                            <h5>{historial.fecha}</h5>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Label>Usuario:</Label>
                                <p>{historial.usuario_nombres} {historial.usuario_apellidos}</p>
                                <Label>Estado:</Label>
                                <p>{historial.estado_nombre}</p>
                                <Label>Comentario:</Label>
                                <p>{historial.comentario}</p>
                            </Row>
                        </CardBody>
                    </Card>
                    <hr />
                </div>
            )

        )
    }
}